module.exports = __webpack_public_path__ + "img/squire1.3409ce25.png";